module.exports = __webpack_public_path__ + "img/logo-light.bbd647c6.png";